
const typeusers = [
    { value: "PP", label: "Porteur de projet" },
    { value: "BF", label: "Investisseur" },
    { value: "ACMPT", label: "Mentor" },
    { value: "visitor", label: "Visiteur" },
];

export default typeusers;